// extracted by mini-css-extract-plugin
module.exports = {"button":"SimpleButton-module--button--1fZBU","outlined":"SimpleButton-module--outlined--qpMnR","alternate":"SimpleButton-module--alternate--3deej"};